import React, { FC } from 'react';
import styles from './folders_dropdown_create_container.module.scss';

export const FoldersDropdownCreateContainer: FC = ({ children }) => (
  <div className={styles.container}>{children}</div>
);
